<template>
  <div :class="mode">
    <AiLayout
      ref="AiLayout"
      :aiType="aiType"
      :status="status"
      :inputMode="inputMode"
      :outputMode="outputMode"
      :styles="styles"
      :mode="mode"
      @addResourceData="confirmAddResource"
      @downloadImg="downloadImg"
      @startIdentify="startIdentify"
      @useCustom="useCustom"
      @emitAccountInfo="emitAccountInfo"
      @insertMethod="insertMethod"
      @remoteAiUse="remoteAiUse"
    >
      <template v-slot:identify-header-right>
        <template v-if="aiType === 'image_enlargement'">
          <span style="margin-right: 10px;">放大倍率：</span>
          <el-radio-group v-model="upscaleFactor" required>
            <el-radio :label="2">2倍</el-radio>
            <el-radio :label="3">3倍</el-radio>
            <el-radio :label="4">4倍</el-radio>
          </el-radio-group>
        </template>
        <template v-else-if="aiType === 'image_matting'">
          <el-radio-group style="margin-right" v-model="mattingType" required>
            <el-radio :label="1">
              通用抠图
              <el-tooltip 
                class="item" 
                effect="dark" 
                placement="top">
                <div slot="content">识别图片中视觉中心的物体轮廓，与背景进行分离，适用于拍摄真实世界的图片，不适用于卡通、手绘图片。</div>
                <i class="el-icon-question" style="margin-right: 10px; position: relative; top: 1px;"></i>
              </el-tooltip>
            </el-radio>
            <el-radio :label="2">
              人像抠图
              <el-tooltip 
                class="item" 
                effect="dark" 
                placement="top">
                <div slot="content">识别图片中的人体轮廓，与背景进行分离，适用于真人图片，不适用于卡通、手绘图片。</div>
                <i class="el-icon-question" style="margin-right: 10px; position: relative; top: 1px;"></i>
              </el-tooltip>
            </el-radio>
          </el-radio-group>
        </template>
        <template v-else-if="aiType === 'image_cropping'">
          <span>
            裁切方式
            <el-popover
              popper-class="base-popover"
              placement="bottom"
              title=""
              width="450"
              trigger="hover"
            >
              <section v-if="haveAutoCropping">● 样式推荐比例：当前样式推荐使用的图片比例，裁剪出样式最佳比例画面；</section>
              <section>● 自动比例：ai通过分析原图内容，给出的最佳裁切比例</section>
              <section>● 原图比例：您上传图片的原始比例，需要满足服务限制；</section>
              <section>● 推荐比例：常用的图片比例，例如16:9、3:4等；</section>
              <section>● 自定义比例：可自定义裁切比例，需要满足服务限制；</section>
              <section>● 服务限制：必须为整数比例，取值范围为(0，20)比例范围必须控制在[0.5-2]之间。</section>
              <i slot="reference" style="margin-left: 3px;" class="el-icon-question" />
            </el-popover>
            ：
          </span>
          <el-select
            v-model="imageCroppingType"
            size="small"
            style="margin-right: 10px; width: 120px;"
          >
            <el-option
              v-for="item in imageCroppingTypeList"
              :disabled="item.disabled"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              {{ item.name }}
            </el-option>
          </el-select>
          <template v-if="imageCroppingType === 'common'">
            <span>常用比例：</span>
            <el-select
              v-model="imageCroppingCommonRadio"
              size="small"
              style="margin-right: 10px;width: 100px;"
            >
              <el-option
                v-for="item in imageCroppingCustomTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                {{ item.name }}
              </el-option>
            </el-select>
          </template>
          <template v-else-if="imageCroppingType === 'custom'">
            <span>自定义：</span>
            <el-input-number
              v-model="imageCroppingCustomRadioWidth"
              size="small"
              :min="1"
              :max="19"
              style="width: 40px;"
              :precision="0"
            />
             : 
            <el-input-number
              v-model="imageCroppingCustomRadioHeight"
              size="small"
              :min="1"
              :max="19"
              style="width: 40px; margin-right: 10px;"
              :precision="0"
            />
          </template>
        </template>
      </template>
      <template v-slot:identify-content>
        <div class="common-content" :style="{ 'height': styles?.tableHeight ? styles.tableHeight + 'px' : '550px'}">
          <template v-if="!resourceData.ref_id">
            <div class="content-uploader" @dragover.prevent @drop="handleDrop($event)" @click="openFile">
              <i class="iconfont upload-icon">&#xe7ed;</i>
              <span class="upload-title">拖拽或点击上传本地图片</span>
              <span class="upload-subTitle">支持PNG、JPG、JPEG、GIF图片，最大支持10.00MB图片</span>
              <div class="upload-tip">
                <div class="tip-card" v-for="(item, index) in tipList" :key="index">
                  <div class="tip-title">{{ item.title }}</div>
                  <div class="tip-content">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="content-img-holder">
              <div class="grid-bak"></div>
              <div class="content-img" ref="contentImg" :style="{ 'background-image': `url(${resourceData.url})` }">
                <div v-show="status === 'ing'" class="loading-holder" ref="loadingHolder"></div>
                <div v-show="status === 'success'" class="identify-holder" ref="identifyImg">
                  <div class="identify-show" ref="identifyShow">
                    <div class="grid-bak"></div>
                    <div class="identify-img" ref="identifyImgCore" :style="{ 'background-image': `url(${identifyData.url})` }"></div>
                  </div>
                  <!-- <div class="identify-img" ref="identifyImg" :style="{ 'background-color': 'rgba(0,0,0,0)', 'background-image': `url(${identifyData.url})` }"></div> -->
                  <div class="identify-drag" ref="identifyDrag" @mousedown="resizeDown($event)">
                    <div class="identify-drag-line"></div>
                    <img v-if="mode === 'rich'" ondragstart="return false" src="data:image/png;base64,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" />
                    <img v-else ondragstart="return false" src="data:image/png;base64,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" />
                  </div>
                  <div class="identify-message new">
                    <span>处理后图片：</span>
                    <span>{{ identifyData.width }}px * {{ identifyData.height }}px</span>
                    <span>{{ formatFileSize(identifyData.length) }}</span>
                  </div>
                  <div class="identify-message old">
                    <span>原始图片：</span>
                    <span>{{ resourceData.width }}px * {{ resourceData.height }}px</span>
                    <span>{{ formatFileSize(resourceData.length) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </AiLayout>
  </div>
</template>

<script>
const statusObj = {
  wait: '待处理',
  ing: '处理中',
  success: '处理完成',
  error: '服务使用超限',
}
import AiLayout from '@/layout/AiLayout.vue'
import { GeneratedServiceStatus, SUCCESS_STATUS } from '../config'
import { formatFileSize } from '@/utils/common'
import { identify } from '@/api/common'
import axios from 'axios'

export default {
  name: 'ImageTool',
  components: {
    AiLayout
  },
  props: {
    inputMode: {
      type: Array,
      default: () => ['file', 'resource'],
    },
    outputMode: {
      type: Array,
      default: () => ['file'],
    },
    inputData: {
      type: Object,
      default: () => {},
    },
    styles: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: String,
    },
    defaultSetting: {
      type: Object,
    },
    aiType: {
      type: String,
      required: true,
    }
  },
  provide() {
    return {
      resourceData: this.resourceData,
    }
  },
  data() {
    return {
      timer: null,

      saveFolderName: '默认文件夹',
      saveFolderId: '',
      upscaleFactor: 2,
      mattingType: 1,
      statusObj:statusObj,

      resourceData: {},
      identifyData: {},
      status: 'wait',

      loadingAnimationTimer: null,
      resizeX: 0,
      tipList: [
        {
          title: '第一步：上传文件',
          content: '支持上传本地图片、素材库图片',
        },
        {
          title: '第二步：开始处理',
          content: '点击“开始处理”按钮，图片进行处理',
        },
        {
          title: '第三步：使用素材',
          content: '可将图片进行下载或直接使用素材库中的图片',
        },
      ],

      imageCroppingCustomTypeList: [
        {
          id: '16:9',
          name: '16:9横图',
        },{
          id: '4:3',
          name: '4:3横图',
        },{
          id: '3:2',
          name: '3:2横图',
        },{
          id: '9:16',
          name: '9:16竖图',
        },{
          id: '3:4',
          name: '3:4竖图',
        },{
          id: '2:3',
          name: '2:3竖图',
        },{
          id: '1:1',
          name: '1:1方图',
        }
      ],
      imageCroppingType: 'auto',
      imageCroppingCommonRadio: '16:9',
      imageCroppingCustomRadioWidth: 16,
      imageCroppingCustomRadioHeight: 9,
      useOriginDisabled: false,
      haveAutoCropping: false,
      autoCroppingRatio: '',

      usageLogId: undefined,
      source: axios.CancelToken.source(),
      pollingTimer: null
    }
  },
  mounted() {
    if (this.inputData && this.inputData.ref_id) {
      if (this.aiType === 'image_cropping' && this.inputData.ratio_w && this.inputData.ratio_h) {
        this.haveAutoCropping = true
        this.autoCroppingRatio = `${this.inputData.ratio_w}:${this.inputData.ratio_h}`
      }
      let processedInputData = {
        ...this.inputData
      };
      // 对于需要进行智能处理的数据，需要取首次处理完的结果进行第二步的处理，所以替换ref_id
      if (this.inputData.rid) {
        processedInputData = {
          ...this.inputData,
          ref_id: this.inputData.rid,
        };
      }

      this.useResource(processedInputData)
    }
  },
  computed: {
    imageCroppingTypeList() {
      const _active_list = []
      if (this.haveAutoCropping) {
        _active_list.push({
          id: 'recommend',
          name: '推荐图片比例',
          disabled: false,
        })
      }
      const _list =  [
        {
          id: 'auto',
          name: '自动比例',
          disabled: false,
        },
        {
          id: 'origin',
          name: '原图比例',
          disabled: this.useOriginDisabled,
        }, {
          id: 'common',
          name: '常用比例',
          disabled: false,
        }, {
          id: 'custom',
          name: '自定义比例',
          disabled: false,
        }
      ]
      return _active_list.concat(_list)
    }
  },
  watch: {
    usageLogId: function(newVal) {
      if (newVal) {
        // 关闭前一次轮询，生成新的source,开始轮训
        this.stopPolling();
        this.generateNewSource();
        this.startPolling();
      } else {
        this.stopPolling();
      }
    }
  },
  methods: {
    formatFileSize,
    generateNewSource() {
      this.source = axios.CancelToken.source();
    },

    startPolling() {
      this.pollingTimer = setInterval(() => {
        this.getGeneratedImg()
      }, 3000);
    },

    stopPolling() {
      clearInterval(this.pollingTimer);
    },
    openResource() {
      this.$refs.AiLayout.showResource()
    },
    handleDrop(event) {
      this.$refs.AiLayout.handleDrop(event)
    },
    openFile() {
      this.$refs.AiLayout.openFile()
    },
    downloadImg() {
      const tag = document.createElement('a')
      tag.setAttribute('download', this.identifyData.file_name)
      tag.href = this.identifyData.url
      tag.click()
    },
    initCroppingMode() {
      if (this.checkRadio(this.getReducedRatio(this.resourceData.width, this.resourceData.height))) {
        this.useOriginDisabled = false
      } else {
        this.useOriginDisabled = true
      }
      if (this.haveAutoCropping) {
        this.imageCroppingType = 'recommend'
      }
    },
    checkRadio(ratioArray) {
      let isOk = true
      const [_width, _height] = ratioArray
      if (_width > 19 || _width < 1) {
        isOk = false
      }
      if (_height > 19 || _height < 1) {
        isOk = false
      }
      if (_width / _height < 0.5 || _width / _height > 2) {
        isOk = false
      }
      return isOk
    },
    getReducedRatio (width, height) {
      function gcd(a, b) {
        if (b === 0) return a;
        return gcd(b, a % b);
      }
      const divisor = gcd(width, height);
      const reducedWidth = width / divisor;
      const reducedHeight = height / divisor;
      return [reducedWidth, reducedHeight];
    },
    startIdentify() {
      if (!this.resourceData.ref_id) {
        this.$message.error('请先选择图片')
        return
      }
      if (this.aiType === 'image_cropping') {
        if (this.imageCroppingCustomRadioWidth / this.imageCroppingCustomRadioHeight < 0.5 ||
         this.imageCroppingCustomRadioWidth / this.imageCroppingCustomRadioHeight > 2) {
          this.$message.error('长宽比')
          return
        }
      }
      this.status = 'ing'
      this.startLoadingAnimation()
      
      const formData = new FormData()
      formData.append('type', this.aiType)
      formData.append('ref_id', this.resourceData.ref_id)
      if (this.$refs.AiLayout.saveFolderId) {
        formData.append('folder_id', this.$refs.AiLayout.saveFolderId)
      }
      if (this.aiType === 'image_enlargement') {
        formData.append('upscale_factor', this.upscaleFactor)
      } else if (this.aiType === 'image_matting') {
        formData.append('matting_type', this.mattingType)
      } else if (this.aiType === 'image_cropping') {
        formData.append('mode', this.imageCroppingType === 'recommend' ? 'custom' : this.imageCroppingType)
        let _ratio = ''
        
        switch(this.imageCroppingType) {
          case 'recommend':
            _ratio = this.autoCroppingRatio
            break;
          case 'origin':
            _ratio = this.getReducedRatio(this.resourceData.width, this.resourceData.height).join(':')
            break;
          case 'common':
            _ratio = this.imageCroppingCommonRadio
            break;
          case 'custom':
            _ratio = this.imageCroppingCustomRadioWidth + ':' + this.imageCroppingCustomRadioHeight
            break;
        }
        formData.append('ratio', _ratio)
      }
      identify(this.aiType, formData).then((response) => {
        // 图像裁切使用同步方案，其他功能使用异步方案
        if (this.aiType === 'image_cropping') {
          this.finishLoadingAnimation()
          this.$message.success('操作完成')
          this.identifyData = response.data
          // 数据赘余
          if (!this.resourceData.width) {
            this.resourceData.width = this.identifyData.origin_width
          }
          if (!this.resourceData.height) {
            this.resourceData.height = this.identifyData.origin_height
          }
          if (!this.resourceData.length) {
            this.resourceData.length = this.identifyData.origin_length
          }
          this.$emit('updateHistory')
          setTimeout(()=>{
            this.status = 'success'
            this.initDragMode()
          }, 1000)
        } else {
          if (response.status === 0) {
            this.usageLogId = response?.data?.usage_log_id;
            this.$emit('updateHistory')
          } else {
            this.$message({
              type: 'error',
              message: response.error
            });

            this.status = 'error';
          }
        }
      })
    },
    async getGeneratedImg() {
      try {
        const { data } = await axios.get(`/index/${this.aiType}/get_usage_log`, {
          params: {
            usage_log_id: this.usageLogId
          },
          cancelToken: this.source.token
        })
        if (data.status === SUCCESS_STATUS) {
            if (![GeneratedServiceStatus.RUNNING, GeneratedServiceStatus.CREATED].includes(data.data.status)) {
              this.usageLogId = undefined;
              this.$emit('updateHistory');

              this.finishLoadingAnimation()
              this.identifyData = data.data
              // 数据赘余
              if (!this.resourceData.width) {
                this.resourceData.width = this.identifyData.origin_width
              }
              if (!this.resourceData.height) {
                this.resourceData.height = this.identifyData.origin_height
              }
              if (!this.resourceData.length) {
                this.resourceData.length = this.identifyData.origin_length
              }
              setTimeout(()=>{
                this.status = 'success'
                this.initDragMode()
              }, 1000)
            }
        } else {
          this.resetResource()
          this.$message.error(data.error);
          this.stopPolling();

          this.status = 'error';
        }
      } catch(err) {
        this.stopPolling();
        this.status = 'error';
      }
    },
    startLoadingAnimation() {
      const _displayHeight = this.$refs.contentImg.offsetHeight
      this.$refs.loadingHolder.style.height = (Math.min(this.$refs.loadingHolder.offsetHeight + 50, _displayHeight)) + 'px'
      this.loadingAnimationTimer = setInterval(() => {
        this.$refs.loadingHolder.style.height = (Math.min(this.$refs.loadingHolder.offsetHeight + 50, _displayHeight)) + 'px'
      }, 500);
    },
    finishLoadingAnimation() {
      const _displayHeight = this.$refs.contentImg.offsetHeight
      this.$refs.loadingHolder.style.height = _displayHeight + 'px'
      clearInterval(this.loadingAnimationTimer)
    },
    initDragMode() {
      // debugger
      const _imgWidth = this.$refs.contentImg.offsetWidth
      const _identifyShow = this.$refs.identifyShow
      const _identifyDrag = this.$refs.identifyDrag
      const _identifyImg = this.$refs.identifyImg
      const _identifyImgCore = this.$refs.identifyImgCore
      _identifyImg.style.width = _imgWidth + 'px'
      _identifyImgCore.style.width = _imgWidth + 'px'
      _identifyShow.style.width = _imgWidth / 2 + 'px'
      _identifyDrag.style.left = _imgWidth / 2 + 'px'
    },
    resizeDown(e) {
      const _identifyShow = this.$refs.identifyShow
      const _identifyDrag = this.$refs.identifyDrag
      const _imgWidth = this.$refs.contentImg.offsetWidth
      const _boxWidth = parseFloat(_identifyShow.style.width)
      this.resizeX = e.clientX
      
      document.onmousemove = (e) => {
        const change =_boxWidth - (this.resizeX - e.clientX)
        if (change < 0) return
        if (change > _imgWidth) return
        _identifyShow.style.width = change + 'px'
        _identifyDrag.style.left = change + 'px'
      }

      document.onmouseup = () => {
        document.onmousemove = null
      }
    },
    resetResource() {
      this.status = 'wait'
      if (this.$refs.loadingHolder) {
        this.$refs.loadingHolder.style.height = '0px'
      }
      this.$forceUpdate()
    },
    confirmAddResource(res) {
      this.useResource( Array.isArray(res) ? res[0] : res)
    },
    useResource(resource) {
      this.resourceData = resource
      if (this.aiType === 'image_cropping') {
        this.initCroppingMode()
      }
      this.resetResource()
    },
    useHistory(item) {
      this.source.cancel('操作取消');

      if ([GeneratedServiceStatus.RUNNING, GeneratedServiceStatus.CREATED].includes(item.status) && this.aiType !== 'image_cropping') {
        this.usageLogId = item.id;

        this.resourceData = {
          ref_id: item.origin_ref_id,
          width: item.origin_width,
          height: item.origin_height,
          length: item.origin_length,
          url: item.origin_file_path,
          file_name: item.origin_file_name,
        }
        this.status = 'ing'

        if (this.aiType === 'image_cropping') {
          this.initCroppingMode()
        }
        this.$message.success('查看成功')
        setTimeout(()=>{
          this.initDragMode()
        }, 1000)
      } else {
        this.usageLogId = undefined;

        this.resourceData = {
          ref_id: item.origin_ref_id,
          width: item.origin_width,
          height: item.origin_height,
          length: item.origin_length,
          url: item.origin_file_path,
          file_name: item.origin_file_name,
        }
        this.identifyData = {
          ref_id: item.file_id,
          width: item.width,
          height: item.height,
          length: item.length,
          url: item.file_path,
          file_name: item.file_name,
        }
        if (this.aiType === 'image_cropping') {
          this.initCroppingMode()
        }
        this.$message.success('查看成功')
        setTimeout(()=>{
          this.status = 'success'
          this.initDragMode()
        }, 1000)
      }
    },
    useCustom() {
      this.$emit('customMethod', this.identifyData)
    },
    insertMethod() {
      this.$emit('insertMethod', this.identifyData)
    },
    emitAccountInfo(info) {
      this.$emit('emitAccountInfo', info)
    },
    remoteAiUse(type) {
      this.$emit('remoteAiUse', type, this.identifyData)
    },
  },

  beforeDestroy() {
    clearInterval(this.loadingAnimationTimer);

    this.source.cancel('操作取消');
    this.stopPolling()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  .el-radio {
    margin-right: 20px;
  }
}
::v-deep .el-input-number {
  .el-input__inner {
    padding: 0 5px;
  }
  .el-input-number__decrease {
    display: none;
  }
  .el-input-number__increase {
    display: none;
  }
}
.common-content {
  display: flex;
}
.content-uploader {
  cursor: pointer;
  flex: 1;
  background-color: #F5F5F5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .upload-icon {
    color: #CCCCCC;
    font-size: 60px;
    margin-bottom: 5px;
  }
  .icon {
    color: #CCCCCC;
    font-size: 60px;
    margin-bottom: 5px;
  }
  .upload-title {
    font-size: 20px;
    color: #333333;
    font-weight: 600;
  }
  .upload-subTitle {
    margin-top: 10px;
    font-size: 14px;
    color: #999999;
  }
  .upload-tip {
    margin-top: 40px;
    display: flex;
    justify-content: space-around;
    .tip-card {
      margin: 0 15px;
      width: 300px;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #FFFFFF;
      border-radius: 3px;
      padding: 0 20px;
      .tip-title {
        font-size: 14px;
        color: #666666;
      }
      .tip-content {
        margin-top: 10px;
        font-size: 13px;
        color: #999999;
      }  
    }
  }
}
.grid-bak {
  position: absolute;
  background-image: linear-gradient(45deg,rgba(0,0,0,.15) 25%,transparent 0,transparent 75%,rgba(0,0,0,.15) 0),
                    linear-gradient(45deg,rgba(0,0,0,.15) 25%,transparent 0,transparent 75%,rgba(0,0,0,.15) 0);
  background-color: #eee;
  background-size: 20px 20px;
  background-position: 0 0,10px 10px;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-repeat: repeat;
}
.content-img-holder {
  flex: 1;
  display: flex;
  position: relative;
}
.content-img {
  flex: 1;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;

  @keyframes loadingEffect {
    0% {
      height: 0%;
    }
    50% {
      height: 50%;
    }
    100% {
      height: 100%;
    }
}
  .loading-holder {
    width: 100%;
    transition: width 1s, height 1s;
    background-image: linear-gradient(-180deg, rgba(237,119,0,0.00) 0%, rgba(237,119,0,0.60) 100%);
    border-bottom: 4px solid #ED7700; 
    animation: loadingEffect 5s linear infinite;
  }
  .identify-holder {
    width: 100%;
    height: 100%;
    .identify-show {
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      height: 100%;
      .identify-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
    .identify-drag {
      cursor: pointer;
      top: 0;
      left: 0;
      position: absolute;
      height: 100%;
      .identify-drag-line {
        width: 4px;
        background-color: #ED7700;
        height: 100%;
      }
      .iconfont {
        border-radius: 50%;
        position: absolute;
        font-size: 40px;
        top: calc(50% - 20px);
        color: #ED7700;
        left: -18px;
        width: 40px;
        height: 40px;
        // background-image: linear-gradient(#FFF, #FFF);
        // background-size: 25px 25px;
        // background-position: center center;
        cursor: pointer;
        user-select: none;
      }
      i:hover, i:focus, i:active {
        // background-image: linear-gradient(#FFF, #FFF);
        // background-size: 25px 25px;
        // background-position: center center;
      }
      i:not(:focus):not(:hover):not(:active) {
        // background-image: linear-gradient(#FFF, #FFF);
        // background-size: 25px 25px;
        // background-position: center center;
        outline: none; /* 取消选中时的轮廓 */
      }
      img {
        position: absolute;
        width: 40px;
        top: calc(50% - 20px);
        left: -18px;
      }
    }
    .identify-message {
      position: absolute;
      top: 20px;
      font-size: 12px;
      color: #FFFFFF;
      display: flex;
      flex-direction: column;
      padding: 12px;
      opacity: 0.6;
      background: #000000;
      border-radius: 3px;
      padding: 8px 12px;
      line-height: 16px;
      &.new {
        left: 20px;
      }
      &.old {
        right: 20px;
      }
    }
  }
}
.content-list {

  overflow-y: auto;
  .dot {
    height: 8px;
    display: inline-block;
    border-radius: 50%;
    width: 8px;
    vertical-align: middle;
    margin-right: 2px;
    &.wait {
      background-color: #FF9C25;
    }
    &.ing {
      background-color: #FF9C25;
    }
    &.success {
      background-color: #67c23a;
    }
    &.error {
      background-color: #F56C6C;
    }
  }
}

.rich {
  .loading-holder {
    background-image: linear-gradient(-180deg, rgba(237,119,0,0.00) 0%, rgba(64, 158, 255,0.60) 100%) !important;
    border-bottom: 4px solid #409EFF !important; 
  }
  .identify-drag-line {
    background-color: #409EFF !important;
  }
  .iconfont {
    color: #999999 !important;
  }
}

.h5 {
  .content-uploader {
    background-color: #2A2A2A !important;
    .upload-icon {
      color: #CCCCCC !important;
    }
    .icon {
      color: #BBBBBB !important;
    }
    .upload-title {
      color: #BBBBBB !important;
    }
    .upload-tip {
      .tip-card {
        background-color: #333333 !important;
        .tip-title {
          color: #999999 !important;
        }
        .tip-content {
          color: #999999 !important;
        }  
      }
    }
  }
}
</style>
